<template>
  <v-navigation-drawer
    :value="isOrganizationDetailsDrawerOpen"
    @input="inputOrganizationDetailsDrawer"
    width="60%"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <BaseToolbar
      title="Detalles de organización / Cliente"
      :dark="true"
      color="#2661FF"
      @close="inputOrganizationDetailsDrawer"
    />
    <div class="pa-8">
      <v-card class="custom_card pa-4" flat>
        <v-card-title class="text-color subtitle-1 font-weight-medium">
          {{ organization.name }}
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center align-center">
            <v-col cols="2">
              <span class="text-color subtitle-2">
                ID:
                <strong class="subtitle-2" style="color: #2661FF;">
                  {{ organization.id }}
                </strong>
              </span>
            </v-col>
            <v-col cols="10">
              <v-chip :color="getStatusObject(organization.status).color">
                {{ getStatusObject(organization.status).text }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            v-for="domain in organization.organizationDomains"
            :key="domain.id"
            class="d-flex justify-center align-center mt-2"
          >
            <v-col cols="2">
              <span class="text-color subtitle-2">
                {{ $t('domains.title') }}
              </span>
            </v-col>
            <v-col cols="10">
              <span class="text-color">
                {{ domain.domain }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <h2 class="title text-color mt-2">
                {{
                  $t(
                    'communications.metrics.organizations.send_email_account.drawer.title'
                  )
                }}
              </h2>
              <p class="text-color mt-2">
                {{
                  $t(
                    'communications.metrics.organizations.send_email_account.drawer.description'
                  )
                }}
              </p>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                v-model="localAccount"
                :items="sendEmailAccounts"
                item-text="name"
                item-value="id"
                label="Cuenta"
                dense
                outlined
                hide-details
                class="rounded-lg"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end mr-2">
          <!-- :disabled="localAccount === organization.sendEmailAccount.id" -->
          <v-btn
            :disabled="true"
            @click="openSaveSendEmailAccountDialog"
            color="#2661FF"
            class="rounded-lg"
          >
            <span class="white--text">
              {{ $t('actions.save') }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="sendEmailAccountDialog.display" width="600">
      <v-card class="custom_card elevation-0" flat>
        <v-card-title class="d-flex justify-between align-center">
          <span class="body-1 font-weight-medium text-color">
            {{
              $t(
                'communications.metrics.organizations.send_email_account.modify.title'
              )
            }}
          </span>
          <v-spacer />
          <v-btn icon @click="closeSaveSendEmailAccountDialog">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6">
          <v-card class="custom_card" color="#1C6E8C" flat>
            <v-card-title class="justify-center">
              <span class="body-2 font-weight-medium white--text">
                {{
                  $t(
                    'communications.metrics.organizations.send_email_account.modify.subheader'
                  )
                }}
              </span>
            </v-card-title>
          </v-card>
        </v-card-text>
        <v-card-text class="mt-2">
          <v-row>
            <v-col cols="12" class="d-flex justify-center align-center">
              <span class="text-color">
                {{
                  $t(
                    'communications.metrics.organizations.send_email_account.modify.description_1'
                  )
                }}
                <strong>
                  {{
                    $t(
                      'communications.metrics.organizations.send_email_account.modify.description_2'
                    )
                  }}
                </strong>
                {{
                  $t(
                    'communications.metrics.organizations.send_email_account.modify.description_3'
                  )
                }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mb-4">
          <v-btn
            :disabled="true"
            :loading="sendEmailAccountDialog.loading"
            @click="saveSendEmailAccount"
            class="rounded-2"
            color="#2661FF"
            block
          >
            <span class="white--text">
              {{
                $t(
                  'communications.metrics.organizations.send_email_account.modify.agree'
                )
              }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar.vue'
import OrganizationMixin from '@/mixins/organization'

export default {
  name: 'OrganizationDetailsDrawer',
  components: {
    BaseToolbar
  },
  mixins: [OrganizationMixin],
  data() {
    return {
      localAccount: null,
      sendEmailAccountDialog: {
        display: false,
        loading: false
      }
    }
  },
  created() {
    this.localAccount = this.organization.sendEmailAccount.id
  },
  computed: {
    ...mapState({
      isOrganizationDetailsDrawerOpen: ({ communicationByOrg }) =>
        communicationByOrg.organizations.isOrganizationDetailsDrawerOpen,
      organization: ({ communicationByOrg }) =>
        communicationByOrg.organizations.organization,
      sendEmailAccounts: ({ communicationByOrg }) =>
        communicationByOrg.organizations.sendEmailAccounts
    })
  },
  methods: {
    ...mapActions({
      saveSendEmailAccountAction: 'communicationByOrg/saveSendEmailAccount'
    }),
    ...mapMutations({
      setOrganizationDetailsDrawer:
        'communicationByOrg/setOrganizationDetailsDrawer'
    }),
    inputOrganizationDetailsDrawer(arg) {
      if (!arg) {
        this.setOrganizationDetailsDrawer(false)
      }
    },
    openSaveSendEmailAccountDialog() {
      this.sendEmailAccountDialog.display = true
    },
    closeSaveSendEmailAccountDialog() {
      this.sendEmailAccountDialog.display = false
    },
    async saveSendEmailAccount() {
      const { id: organizationId } = this.organization
      this.sendEmailAccountDialog.loading = true
      await this.saveSendEmailAccountAction({
        organizationId,
        sendEmailAccountId: this.localAccount
      })

      this.sendEmailAccountDialog.loading = false
      this.sendEmailAccountDialog.display = false
    }
  }
}
</script>

<style lang="scss" scoped>
.text-color {
  color: #212121;
}
</style>
